// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/select-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../img/icon-plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../img/icon-minus.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple_input {
    display: flex;
    flex-direction: column;
}

.simple_label {
    font-size: 12px;
    font-weight: 500;
    line-height: 27px;
    color: #0E0A40;
}

@media (max-width: 400px){
    .simple_label {
        font-size: 12px;
        font-weight: 500;
        margin-left: 5px;
        margin-top: 0em;
        color: #0E0A40;
    }
}

.simple_input input, select.simple_input {
    font-family: 'Montserrat', sans-serif;
    -webkit-appearance: none;
    margin-top: 5px;
    height: 42px;
    border: 1px solid rgba(14, 10, 64, 0.15);
    border-radius: 5px;
    padding-left: 10px;
    margin-bottom: 15px;
    font-size: 0.8rem;
    font-weight: 500;
    color: #37454D;
}
@media (max-width: 400px){
    .simple_input {
        display: flex;
        flex-direction: column;
        padding: 0%;
    }
}




.csv_upload_input {
    padding-left: 5px;
    font-family: 'Montserrat', sans-serif;
    -webkit-appearance: none;
    height: 30px;
    border: 1px solid rgba(14, 10, 64, 0.15);
    border-radius: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #37454D;
}

input:hover {
    border: 1.5px solid rgba(14, 10, 64, 1);
}

select.simple_input:hover {
    border: 1.5px solid rgba(14, 10, 64, 1);
}


input:focus {
    border: 2px solid #0062FF;
}

.search_container input:focus {
    border: none;
}
.search_container input:hover {
    border: none;
}

.simple_input:disabled {
    background-color: #f1f1f5;
    height: 40px;
}

.simple_input:disabled::placeholder {
    color: rgba(0, 0, 0, 0.5);
}

.simple_input input::placeholder, select.simple_input {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #9aa9b3;
}

textarea::placeholder {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #9aa9b3;
}

select.simple_input {
    padding-top: 12px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat right 1rem center;
    background-color: #ffffff;
}

.expand.simple_input {
    background: #D6D6DF url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right;
}

.collapse.simple_input {
    background: #D6D6DF url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat right;
}
`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/Inputs.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,cAAc;IAClB;AACJ;;AAEA;IACI,qCAAqC;IACrC,wBAAwB;IACxB,eAAe;IACf,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;IACf;AACJ;;;;;AAKA;IACI,iBAAiB;IACjB,qCAAqC;IACrC,wBAAwB;IACxB,YAAY;IACZ,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uCAAuC;AAC3C;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,+EAAuE;IACvE,yBAAyB;AAC7B;;AAEA;IACI,2EAAgE;AACpE;;AAEA;IACI,2EAAiE;AACrE","sourcesContent":[".simple_input {\n    display: flex;\n    flex-direction: column;\n}\n\n.simple_label {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 27px;\n    color: #0E0A40;\n}\n\n@media (max-width: 400px){\n    .simple_label {\n        font-size: 12px;\n        font-weight: 500;\n        margin-left: 5px;\n        margin-top: 0em;\n        color: #0E0A40;\n    }\n}\n\n.simple_input input, select.simple_input {\n    font-family: 'Montserrat', sans-serif;\n    -webkit-appearance: none;\n    margin-top: 5px;\n    height: 42px;\n    border: 1px solid rgba(14, 10, 64, 0.15);\n    border-radius: 5px;\n    padding-left: 10px;\n    margin-bottom: 15px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: #37454D;\n}\n@media (max-width: 400px){\n    .simple_input {\n        display: flex;\n        flex-direction: column;\n        padding: 0%;\n    }\n}\n\n\n\n\n.csv_upload_input {\n    padding-left: 5px;\n    font-family: 'Montserrat', sans-serif;\n    -webkit-appearance: none;\n    height: 30px;\n    border: 1px solid rgba(14, 10, 64, 0.15);\n    border-radius: 5px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #37454D;\n}\n\ninput:hover {\n    border: 1.5px solid rgba(14, 10, 64, 1);\n}\n\nselect.simple_input:hover {\n    border: 1.5px solid rgba(14, 10, 64, 1);\n}\n\n\ninput:focus {\n    border: 2px solid #0062FF;\n}\n\n.search_container input:focus {\n    border: none;\n}\n.search_container input:hover {\n    border: none;\n}\n\n.simple_input:disabled {\n    background-color: #f1f1f5;\n    height: 40px;\n}\n\n.simple_input:disabled::placeholder {\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.simple_input input::placeholder, select.simple_input {\n    font-family: 'Montserrat', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    color: #9aa9b3;\n}\n\ntextarea::placeholder {\n    font-family: 'Montserrat', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    color: #9aa9b3;\n}\n\nselect.simple_input {\n    padding-top: 12px;\n    background: url(../../img/select-arrow.svg) no-repeat right 1rem center;\n    background-color: #ffffff;\n}\n\n.expand.simple_input {\n    background: #D6D6DF url(../../img/icon-plus.svg) no-repeat right;\n}\n\n.collapse.simple_input {\n    background: #D6D6DF url(../../img/icon-minus.svg) no-repeat right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
